export const pageCustomerGroup = {
  ['LC_Perm_RI_SPFU_BPI']: 'basic',
  ['LC_Nuevas_Adv_BPI']: 'advance',
  ['LC_Perm_RI_SPFU_Prem_BPI']: 'premier',
  ['LC_Perm_RevIni_SPFU_BPI']: 'basic',
  ['LC_Perm_RS_SPFU']: 'premier',
  ['Sub_Rev_OH']: 'basic',
  ['LC_Perm_RS_Adva_BPI']: 'advance',
  ['LC_Perm_RS_Premier_BPI']: 'premier',
  ['LC_Recom_Rev_Adva_BPI']: 'advance',
  ['LC_Recom_Rev_Premier_BPI']: 'premier',
  ['Nva_Rev_OH']: 'basic',
  ['Simple_Nom_M']: 'basic',
  ['Simple_CP_M']: 'basic',
  ['Simple_Nom_A']: 'advance',
  ['Simple_CP_A']: 'advance',
  ['Simple_Nom_P']: 'premier',
  ['Simple_CP_P']: 'premier',
  ['Simple_CP']: 'basic',
  ['Simple_Nom']: 'basic',
  ['Simple_Nom_Saldos_P']: 'basic',
  ['Nva_TopUp']: 'basic',
  ['Nva_TopUp_CP']: 'basic',
  ['TopUp_AN_MB']: 'basic',
  ['TopUp_CP_MB']: 'basic',
  ['Simple_Nom_Mob']: 'basic',
  ['Simple_CP_Mob']: 'basic',
  ['Pasivos_AN_Mob']: 'basic',
  ['Pasivos_CP_Mob']: 'basic',
  ['TopUp_AN_Mob']: 'basic',
  ['TopUp_CP_Mob']: 'basic',
  ['Refill_Nom_Mob']: 'basic',
  ['Refill_CP_Mob']: 'basic',
  ['Simple_MenoresCP_Mob']: 'basic',
  ['Simple_MenoresAN_Mob']: 'basic',
};
